import { DialogContent, pxToRem, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const PickerContent = styled(DialogContent) `
  position: relative;
  padding: ${theme.spacing['2xl']};
  border-top: solid ${pxToRem(1)} ${theme.semantic.border.default};
  border-bottom: solid ${pxToRem(1)} ${theme.semantic.border.default};
`;
